import { useAuthStore } from '@/v2/store/shared/auth-store';
import {
	doc,
	setDoc,
	deleteDoc,
	getDocs,
	collection,
	query,
	where,
	getDoc,
	addDoc,
} from 'firebase/firestore';
import { db, eduDb } from '@/firebase';
import { Alert } from '@/v2/plugins/alert';
import { t } from '@/locales/index';
import { api } from '@/v2/plugins/axios';
import { callFirebaseFunction } from '@/v2/utils/firebase';

export const DiscountType = Object.freeze({
	Value: 'value',
	Percentage: 'percentage',
});

export const DiscountAppliedOn = Object.freeze({
	Registration: 'registration',
   Diploma: 'diploma',
   Package: 'package',
});
export class Registration {
	id = null;
	studentName = null;
	studentIdNumber = null;
	deplomaName = null;
	timePeriod = null;
	studentIdFile = null;
	highSchoolCertificateFile = null;
	needTransportation = null;
	createdAt = null;
	gender = null;
	city = null;
	neighborhood = null;
	status = null;
	payment = null;
	paymentMethod = null;

	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}

	async update(data) {
		await callFirebaseFunction(
			'educationUpdateRegistrationFromDashboard',
			{
				id: this.id,
				...data,
			},
			{ method: 'put' },
		);
	}

	async remove() {
		await callFirebaseFunction(
			'educationDeleteRegistration',
			{  
            data: {
   				id: this.id,
            },
			},
			{ method: 'delete' },
		);
	}

	async setPaymentStatus(status) {
		const data = {
			paymentStatus: status,
		};
		if (this.status === registrationStatusEnum.PendingPayment) {
			data.status = registrationStatusEnum.Reviewing;
		}
		const authStore = useAuthStore();
		const tenantId = authStore.tenantId;

		const registrationDocRef = doc(
			db,
			`tenants/${tenantId}/education/default/registrations`,
			this.id,
		);

		await setDoc(registrationDocRef, data, { merge: true });
		this.paymentStatus = status;
		if (this.status === registrationStatusEnum.PendingPayment) {
			this.status = registrationStatusEnum.Reviewing;
		}
	}

	static async exportData(filters = {}, tenantId) {
		const authStore = useAuthStore();
		const idToken = await authStore.getIdToken();
		const res = await api.post(
			`${process.env.MIX_API_FUNCTION_URL_EXECUTE_ACTION}`,
			{
				filters,
			},
			{
				params: {
					actionName: 'exportRegistration',
				},
				headers: {
					tenantId,
					userId: 'temp',
					'x-firebase-token': idToken,
				},
			},
		);
		return res.data?.result?.downloadURL;
	}
}

export const registrationStatusEnum = Object.freeze({
	Pending: 'pending',
	Completed: 'completed',
	Rejected: 'rejected',
	PendingDocuments: 'pending_document',
	PendingPayment: 'pending_payment',
	Reviewing: 'reviewing',
	Canceled: 'canceled',
});

export const registrationStatusBadgeVariant = Object.freeze({
	[registrationStatusEnum.Pending]: 'warning',
	[registrationStatusEnum.Completed]: 'success',
	[registrationStatusEnum.Rejected]: 'error',
	[registrationStatusEnum.PendingDocuments]: 'warning',
	[registrationStatusEnum.PendingPayment]: 'warning',
	[registrationStatusEnum.Reviewing]: 'info',
	[registrationStatusEnum.Canceled]: 'error',
});

export const registrationPaymentStatusEnum = Object.freeze({
	Pending: 'pending',
	Paid: 'paid',
	Failed: 'failed',
	Refunded: 'refunded',
});

export const registrationPaymentMethodEnum = Object.freeze({
	MyFatoorah: 'my_fatoorah',
	CashOnDelivery: 'cash_on_delivery',
	BankTransfer: 'bank_transfer',
});

export const registrationPaymentStatusBadgeVariant = Object.freeze({
	[registrationPaymentStatusEnum.Pending]: 'warning',
	[registrationPaymentStatusEnum.Paid]: 'success',
	[registrationPaymentStatusEnum.Failed]: 'error',
	[registrationPaymentStatusEnum.Refunded]: 'gray',
});
